import React, { useEffect } from 'react';
import Button from '../Button/Button';
import './ConfirmationPopap.css';

const popupMessages = {
  logout: 'Хотите выйти из аккаунта?',
  delete: 'Хотите удалить аккаунт? Это действие нельзя отменить.',
};

function ConfirmationPopup({ type, isActive, onConfirm, onClose }) {
  const message = popupMessages[type] || 'Вы уверены?';

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('popup')) {
      onClose();
    }
  };

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') {
        onClose();
      }
    }
    if (isActive) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isActive, onClose]);

  return (
    <div className={`popup ${isActive ? 'popup_active' : ''}`} onClick={handleOverlayClick}>
      <div className="popup__content">
        <p className="popup__message">{message}</p>
        <div className="popup__buttons">
          <Button buttonName="Подтвердить" additionalClass="popup__confirm" onClick={onConfirm} />
          <Button buttonName="Отмена" additionalClass="popup__cancel" onClick={onClose} type="button" />
        </div>
      </div>
    </div>
  );
}

export default ConfirmationPopup;
